import { ItemType } from '@varo/graphql-schema-types';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import BodyBaseBoldText from 'shared/components/vxl/typography/primary/body/BodyBaseBoldText';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import theme from 'shared/styles/theme';

export interface ContentListProps {
  /** You can pass array of strings or the combination of ReactElement & strings array  */
  contentList: React.ReactNode[];
  /** The default type will be `Bullet`, if you are using it for numbering then need to specify type Number  */
  itemType?: ItemType;
}

export default function ContentList({
  contentList,
  itemType = ItemType.Bullet,
}: ContentListProps) {
  return (
    <View style={styles.container}>
      {contentList.map((content, index) => (
        <View
          key={`${+index}`}
          style={styles.itemContainer}
          role="listitem"
          accessible
        >
          {itemType === ItemType.Bullet ? (
            <View
              accessibilityLabel="bullet-point"
              style={styles.bulletPointStyle}
            />
          ) : null}
          {itemType === ItemType.Number ? (
            <View accessibilityLabel="number-point" style={styles.numberStyle}>
              <BodyBaseBoldText numberOfLines={1}>
                {`${(index += 1)}.`}
              </BodyBaseBoldText>
            </View>
          ) : null}
          <BodyBaseText style={styles.textStyle} testID="content-list-item">
            {content}
          </BodyBaseText>
        </View>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  bulletPointStyle: {
    backgroundColor: theme.color.text.primary,
    borderRadius: 8,
    height: 8,
    margin: theme.spacing.s,
    width: 8,
  },
  container: {
    gap: theme.spacing.s,
  },
  itemContainer: {
    flexDirection: 'row',
    gap: theme.spacing.s,
  },
  numberStyle: {
    alignItems: 'center',
    gap: theme.spacing.s,
    width: 24,
  },
  textStyle: { flexShrink: 1 },
});
